import api from './api';

export async function getUpdateNotes() {
  const response = await api.get('/getUpdateNotes');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function getUpdateNote(id) {
  const response = await api.get(`/getUpdateNote/${id}`);
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function createUpdateNote(title, content, date) {
  const response = await api.post('/createUpdateNote', { title, content, date });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function modifyUpdateNote(noteId, title, content, date) {
  const response = await api.post('/modifyUpdateNote', { noteId, title, content, date });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function deleteUpdateNote(noteId) {
  const response = await api.post('/deleteUpdateNote', { noteId });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}
